import invariant from "tiny-invariant";
import baseHomeImageUrl from "/src/assets/images/base/home.svg";
import baseHomeImageCo1Url from "/src/assets/images/base/VOISLOG_Home_Co1.png";
import baseBannerUrl from "/src/assets/images/base/banner.svg";
import sompoHomeImageUrl from "/src/assets/images/sompo/SOMPOCare_Home.png";
import sompoBannerUrl from "/src/assets/images/sompo/SOMPOCare_banner.png";
import uixHomeImageUrl from "/src/assets/images/uix/UIX_Home.png";
import uixBannerUrl from "/src/assets/images/uix/UIX_Banner.png";
import nttHomeImageUrl from "/src/assets/images/ntt/NTT_Home.svg";
import nttBannerUrl from "/src/assets/images/ntt/NTT_Banner.svg";
import tokioDRHomeImageUrl from "/src/assets/images/tokio-dr/home_DR.png";
import tokioDRBannerUrl from "/src/assets/images/tokio-dr/banner_DR.png";
import {
  AppType,
  SupportedAnalysisEngineType,
  isSupportedAnalysisEngineType,
  isKnownAnalysisEngineType,
} from "./types";
function message(name: string, value: unknown): string {
  return `Environment Variable Error: VITE_${name}(${value}) is invalid!`;
}

const baseUrl = import.meta.env.VITE_BASE_API_URL;
invariant(typeof baseUrl === "string", message("BASE_API_URL", baseUrl));
export const BASE_URL = baseUrl;

const voislogApiUrl = import.meta.env.VITE_VOISLOG_API_URL;
invariant(
  typeof voislogApiUrl === "string",
  message("VOISLOG_API_URL", voislogApiUrl),
);
export const VOISLOG_API_URL = voislogApiUrl;

const appName = import.meta.env.VITE_APP_NAME;
invariant(typeof appName === "string", message("APP_NAME", appName));
export const APP_NAME = appName;

const validAppTypes: AppType[] = ["base", "sompo", "uix", "ntt", "tokio-dr"];
export const APP_TYPE: AppType = validAppTypes.includes(
  import.meta.env.VITE_APP_TYPE,
)
  ? import.meta.env.VITE_APP_TYPE
  : "base";
export const HOME_IMAGE_URL = (() => {
  if (import.meta.env.VITE_CO1_DEMO_MODE === "true") {
    return baseHomeImageCo1Url;
  } else {
    switch (APP_TYPE) {
      case "base":
        return baseHomeImageUrl;
      case "sompo":
        return sompoHomeImageUrl;
      case "uix":
        return uixHomeImageUrl;
      case "ntt":
        return nttHomeImageUrl;
      case "tokio-dr":
        return tokioDRHomeImageUrl;
    }
  }
})();

export const BANNER_IMAGE_URL = (() => {
  switch (APP_TYPE) {
    case "base":
      return baseBannerUrl;
    case "sompo":
      return sompoBannerUrl;
    case "uix":
      return uixBannerUrl;
    case "ntt":
      return nttBannerUrl;
    case "tokio-dr":
      return tokioDRBannerUrl;
  }
})();

export const HIDE_LANGUAGE_SELECTION =
  import.meta.env.VITE_HIDE_LANGUAGE_SELECTION === "true";

const defaultLanguage = import.meta.env.VITE_DEFAULT_LANGUAGE;
export const DEFAULT_LANGUAGE =
  typeof defaultLanguage !== "string" || defaultLanguage === "unset"
    ? undefined
    : defaultLanguage;

export const USE_ANALYSIS_ERROR_PAGE =
  import.meta.env.VITE_USE_ANALYSIS_ERROR_PAGE === "true";

const enabledEngines = import.meta.env.VITE_ENABLED_ENGINES;
invariant(
  typeof enabledEngines === "string",
  message("ENABLED_ENGINES", enabledEngines),
);
export const ENABLED_ENGINES: SupportedAnalysisEngineType[] = enabledEngines
  .split("&")
  .flatMap((engine) => (isKnownAnalysisEngineType(engine) ? engine : []))
  .filter(isSupportedAnalysisEngineType);

export const DEBUG_AUDIO_PLAYER =
  import.meta.env.VITE_DEBUG_AUDIO_PLAYER === "true";

export const ENABLE_FILE_ANALYSIS =
  import.meta.env.VITE_ENABLE_FILE_ANALYSIS === "true";

export const CO1_DEMO_MODE = import.meta.env.VITE_CO1_DEMO_MODE === "true";

// VITE_STOP_RECORDING_BUFFERに数値が指定されていればその値を使う(0も可)
export const STOP_RECORDING_BUFFER = Number.isNaN(
  parseInt(import.meta.env.VITE_STOP_RECORDING_BUFFER, 10),
)
  ? 650
  : parseInt(import.meta.env.VITE_STOP_RECORDING_BUFFER, 10);

export const ENABLE_AUTO_LOGIN =
  import.meta.env.VITE_AUTOLOGIN_USER !== undefined &&
  import.meta.env.VITE_AUTOLOGIN_PASS !== undefined;

export const AUTOLOGIN_USER = import.meta.env.VITE_AUTOLOGIN_USER;

export const AUTOLOGIN_PASS = import.meta.env.VITE_AUTOLOGIN_PASS;
